export default {
  title: "Тарифы",
  tariff: "Тариф",
  yourTariff: "Ваш тариф",
  lessTariffModal: {
    title: "Выпуск подарочных карт на вашем тарифе недоступен",
    subtitle:
      "Чтобы выпустить подарочные карты, перейдите на тариф «Промо» или «Про+»",
  },
  lite_p: {
    title: "Лайт",
    list: [
      '<span itemprop="name">Регистрация 1 организации',
      '<span itemprop="name">Создание 5 торговых точек',
      '<span itemprop="name">Упрощенная статистика',
      '<span itemprop="name">Доступ к RC KASSA',
      '<span itemprop="name">Электронный документооборот',
      '<span itemprop="name">Взаиморасчеты 2 раза в месяц',
      '<span itemprop="name">Раздел вопросов и ответов',
    ],
  },

  promo_p: {
    title: "Промо",
  },

  pluspro_p: {
    title: "Про+",
  },

  faq: [
    {
      title: "Как происходит оцифровка клиента?",
      text:
        "<p>Для оцифровки клиента вам необходимо предоставить ему промокод. Он может быть в виде реферальной ссылки, QR-кода или непосредственно самого кода оцифровки. С его использованием клиенту необходимо пройти регистрацию в клиентском сервисе rcpay.ru.</p>" +
        "<br>" +
        "<p>Обратите внимание: чтобы считать QR-код, клиенту понадобится камера с соответствующей функцией или специальное приложение для считывания QR-кодов.</p>",
    },
    {
      title: "Что значит «активный» клиент?",
      text:
        "<p>Это оцифрованный вами клиент, который совершил покупку в онлайн- или офлайн-заведении экосистемы RC Group. Онлайн-покупки подразумевают шопинг в RC Market, приобретение сертификатов, активацию сервисов Яндекс, покупку пользовательского тарифа. Операции в офлайн — это покупки в заведениях в городе с использованием RC.Kassa.</p>" +
        "<br>" +
        "<p>При покупке тарифа «Корпоративный» каждый партнер участвует в акции  «скидка 50%» на продление тарифа. Основное условие этой акции — оцифровать от 500 «активных» клиентов.</p>",
    },
    {
      title: "Что будет, если не продлить тариф?",
      text: "<p>В таком случае функционал кабинета сократится до уровня тарифа «Базовый». Вам останется доступен подраздел «Список клиентов», но вы лишитесь возможности выпускать карты Wallet, отправлять Push-уведомления и доступа к сервису «Безналичные чаевые».</p>",
    },
    {
      title: "Как привлечь и оцифровать больше клиентов?",
      text: "<p>Используйте функционал «Поделиться» для размещения в соцсетях реферальной ссылки на оцифровку. А также размещайте тейбл-тенты, наклейки-стикеры, листовки, воблеры в вашем заведении.</p>",
    },
    {
      title: "Моего вопроса нет, как получить ответ?",
      text:
        "<p>Задайте вопрос в техподдержку. Для этого нажмите на значок RC Group в правом нижнем углу, выберите «Telegram» и опишите в сообщении свою проблему, по необходимости приложите скрины. С вами обязательно свяжется наш специалист, чтобы решить вопрос в кратчайшие сроки. </p>" +
        "<br>" +
        "<p>Также можно отправить письмо на email: <a href='mailto:hello@rc.company'>hello@rc.company</a> </br>" +
        "<br>" +
        "Или позвонить по телефону: <b>8 (800) 500-57-62.</b></p>",
    },
  ],
  digitizedClientsCounter: "Счетчик оцифрованных клиентов",
  activeClientsDigitized: "Оцифровано активных клиентов",
  reg500AndMoreClients:
    "Зарегистрируйте 500 и более <b>активных клиентов</b> в программу лояльности для получения скидки 50% на продление тарифа",
  choosePointToGenerateQr:
    "Выберите торговую точку, чтобы сгенерировать ссылку и QR-код для регистрации новых клиентов в RC PAY.",
  afterBuyTariffYouCanGenerate:
    "После покупки тарифа станет доступна возможность сгенерировать ссылку и QR-код для регистрации новых клиентов в RC PAY.",
  useLinkAndQrForRegNewClients:
    "Используйте ссылку и QR-код для регистрации новых клиентов в RC PAY.",
  shareLink: "Поделиться ссылкой",
  anyOtherQuestions: "Остались вопросы?",
  tariffSuccessPayed: "Тариф «{tariff}» успешно оплачен",
  tariffPayFromMainEntity:
    "Оплата тарифа осуществляется с фактического баланса<br />основного юрлица.",
  period: "Период",
  cost: "Стоимость",
  discount: "Скидка {discount}%",
  totalToPay: "Итого к оплате",
  lite: "Лайт",
  promo: "Промо",
  plusPro: "Про+",
  basic: "Базовый",
  corporate: "Корпоративный",
  popular: "Популярный",
  advanced: "Расширенный",
  includesToTariff: "Входит в тариф",
  allInLitePlus: "Все с тарифа Лайт, плюс",
  allInPromoPlus: "Все с тарифа Промо",
  allInBasicPlus: "Все с тарифа Базовый, плюс",
  forFree: "Бесплатно",
  buyTariff: "Купить тариф",
  tradingPoints: "торговых точек",
  products: "Товаров",
  unlimitProducts: "Товары безлимитно",
  uCanAddProductsToEMenu:
    "Можно добавить {productsCount} товаров в онлайн-каталог и получать онлайн-заказы на них из RC PAY",
  canAddUnlimitProductsToEMenu:
    "Можно добавить безлимитное количество товаров в онлайн-каталог и получать онлайн-заказы на них из RC PAY",
  twoTgMailingPerWeek: "2 рассылки в Telegram в неделю",
  oneTgMailingPerDay: "1 рассылка в Telegram в день",
  canCreateAndSend2NotifyPerWeek:
    "Можно создать и отправить 2 уведомления в неделю клиентам каждой торговой точки в Telegram-бот",
  canCreateAndSend1NotifyPerDay:
    "Можно создать и отправить 1 уведомление в день клиентам каждой торговой точки в Telegram-бот",
  basicAnalytics: "Базовая аналитика",
  analyticsHint: "Аналитика по торговым точкам и юрлицам",
  accrualDeducationPoints: "Начисление и списание баллов в RC KASSA",
  enablingPaymentMethods: "Подключение способов оплаты",
  postingYourShopsInRC: "Размещение ваших заведений в RC PAY",
  postingYourShopsHint:
    "При условии их соответствия правилам размещения в RC PAY<br><br><a target='_blank' href='/docs/Правила размещения.pdf'>См. правила размещения заведений в RC PAY</a>",
  gettingOnlineOrders: "Получение онлайн-заказов на ваши товары/услуги",
  orderPromotionYourShops: "Заказ продвижения ваших торговых точек",
  advancedAnalytics: "Расширенная аналитика",
  advancedAnalyticsHint:
    "Аналитика по торговым точкам, юрлицам, кассирам, клиентам и RFM-анализ",
  evaluationCashierWork: "Оценка работы кассиров",
  digitizingClients: "Оцифровка клиентов",
  accessToClientsList: "Доступ к списку клиентов",
  infoAboutAllClients:
    "Информация обо всех клиентах, посещавших ваше заведение, их контакты, чеки и статистика",
  pushNotifyToClientWalletCard: "Push-уведомления клиентам на карту Wallet",
  scoringPointsByGroups: "Начисление баллов по группам клиентов",
  uCanSetDifferentPercentAward:
    "Можно установить разный % вознаграждения в зависимости от суммы покупок клиентов",
  distributionRCCard: "Распространение карт RC",
  designWalletCard: "Дизайн карты Wallet",
  issuingGiftCard: "Выпуск подарочных карт",
  priorityMaintenance: "Приоритетное обслуживани",
  monetizationUpTo30Percent:
    "Монетизация до 30% от начисленного вознаграждения клиента",
  monetizationHint:
    "При наличии у вас возможности получения дохода от программы лояльности в рамках осуществления деятельности для которой создавалась ваша организация",
  adding1Entity: "Добавление 1 юрлица",
  accessToOperationsHistory: "Доступ к истории операций",
  basicCabinetFunctional: "Базовый функционал кабинета",
  discountOnTariffRenewal: "Скидка 50% на продление тарифа",
  discountOnTariffRenewalHint:
    "Скидка 50% предоставляется, если с момента последней покупки тарифа вы оцифровали 500 и более активных клиентов<br><br><a href='#clients-counter'>См. счетчик клиентов</a>",
  autoConnectIfFreeTariff:
    "Подключается автоматически, если не куплен платный тариф.",
  tariffBuyingWillAvailableFromDate: "Покупка тарифа будет доступна с {date}",
  entityOnModeration: "Юрлицо находится на модерации",
  tariffBuyingWillAvailableAfterModeration:
    "Покупка тарифа будет доступна после того, как юрлицо пройдет модерацию.",
  notEnoughMoney: "Недостаточно средств",
  tariffPayingFromFactBalance:
    "Оплата тарифа осуществляется с фактического баланса основного юрлица.",
  forBuyingTariffNeedReplenish:
    "Для покупки тарифа «{tariff}» необходимо пополнить баланс {entity} на сумму не менее {sum} ₽",
  replenishBalance: "Пополнить баланс",
  canCreate: "Можно создать",
  forTransitionToTariffConnectWithUs:
    "Для перехода на платный тариф обратитесь, пожалуйста, в техническую поддержку",
  paidBefore: "Оплачен до",
};
